import { render, staticRenderFns } from "./Installations.vue?vue&type=template&id=60d1f262&scoped=true"
import script from "./Installations.vue?vue&type=script&lang=ts"
export * from "./Installations.vue?vue&type=script&lang=ts"
import style0 from "./Installations.vue?vue&type=style&index=0&id=60d1f262&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d1f262",
  null
  
)

export default component.exports